import React, { useState, useEffect, useRef } from "react";
import {Link } from 'react-router-dom'
import $ from "jquery";
import axiosInstance from "../../../services/api";
import "datatables.net";
import "../../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css"
import "datatables.net-responsive-dt";
import "../../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import Loader from '../../Commons/Loader';

function AllPermission() {
    const tableRef = useRef(null);
    const [rolePermissionListData, setRolePermissionListData] = useState([]); // Set initial state as an empty array
    const [loading, setLoading] = useState(true);
    // This function simulates an API call that requires authentication
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('user/permission/get-all-permissions'); // Make a GET request
            setRolePermissionListData(response.data.data || []); // Set the entire array of users
        } catch (error) {
            console.error('Error fetching data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
            fetchData();
    }, []);

    useEffect(() => {
        if (rolePermissionListData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true,  // Destroy previous instance
                paging: true,    // Enable pagination
                searching: true, // Enable search
                lengthChange: true, // Enable show entries dropdown
                ordering: true,  // Enable sorting
                responsive: {
                   
                },
                columnDefs: [
                    { targets: 0, responsivePriority: 0 }, // Name - Always visible
                ],
                columns: [
                    { title: "Name" },
                    { title: "Description" }
                ]
            });

            return () => {
                table.destroy(); // Clean up DataTable instance on unmount
            };
        }
    }, [rolePermissionListData]); // Run when `userListingData` changes
    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    
  
    return (
        <>
            {loading && <Loader />} 
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">All Permission</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">All Permission</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <table ref={tableRef} className="display styled-table permission-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rolePermissionListData.length > 0 && rolePermissionListData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                </tr>
                            ))}
                            {rolePermissionListData.length === 0 && (
                                <tr>
                                    <td colSpan="2" className="text-center">Loading...</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    );
}
  
export default AllPermission;